export const defauleBoxValue = {
    show: false,
    title: '',
    method: '',
    noRetry: false
};

export const defaultVideoValue =  {
    // 视频内容
    video: [],
    // 视频上传后-选择视频画面list
    peopleList: [],
    // 视频上传后-选择截图画面是否展示
    showChoosePeople: false,
    // 视频上传后-选择截图画面内容
    peopleChoose: {},
    // 视频上传后-选择截图画面后，内容信息卡片展示
    showChoosePeopleCard: false,
    // IP标签内容
    ipTag: [],
    // IP标签内容展示
    showIpTag: false,
    // IP按钮点击生成-IP列表
    ipList: [],
    // IP按钮点击生成-IP列表 是否展示
    showChooseIp: false,
    // 展示loading
    showLoading: false,
    // 展示loading-title
    loadingTitle: '视频画面提取中',
    // 生成失败展示
    failBoxValue: defauleBoxValue,
    // 主标题提示
    descTextSug: null,
    // 副标题提示
    mainTextSug: null
};

export const defaultImageValue =  {
    // 图片内容
    image: [],
    // IP标签内容
    ipTag: [],
    // IP标签内容展示
    showIpTag: false,
    // IP按钮点击生成-IP列表
    ipList: [],
    // IP按钮点击生成-IP列表 是否展示
    showChooseIp: false,
    // IP按钮点击生成-IP列表 用户选择（单选）
    ipChoose: [],
    // 展示loading
    showLoading: false,
    // 展示loading-title
    loadingTitle: 'IP生成中',
    // 生成失败展示
    failBoxValue: defauleBoxValue
};

export const defaultIntelFormData = {
    coverPicture: {
        // ip生成类型: 1.video 2.image
        type: 'video',
        videoValue: defaultVideoValue,
        imageValue: defaultImageValue
    }
};

export const defaultDesignFormData = {
    templateGroup: {
        industry: {
            value: ''
        },
        sizeControl: {
            // 选择：choose
            // 自定义：custom
            type: 'choose',
            value: {
                ratio: '16:9',
                dimension: '1140*640',
                customWidth: '',
                customHeight: ''
            }
        },
        template: {
            chooseList: []
        },
        showOuterChoose: true,
        showCheckedCon: false
    },
    // ip名称
    ipName: {
        value: ''
    },
    // ip职位
    ipPosition: {
        value: ''
    },
    // 主标题
    mainText: {
        value: ''
    },
    // 副标题
    descText: {
        value: ''
    },
    // 按钮文案
    buttonText: {
        value: ''
    },
    // 风险提示语
    riskText: {
        value: ''
    },
    // 品牌logo
    brandLogo: {
        image: []
    },
    brandName: {
        value: ''
    }
};
